module.exports = __webpack_public_path__ + "img/9368364b0e270cf36a2e60b558c30e55.png";